import { render, staticRenderFns } from "./rightsManagement.vue?vue&type=template&id=6bebf863"
import script from "./rightsManagement.vue?vue&type=script&lang=js"
export * from "./rightsManagement.vue?vue&type=script&lang=js"
import style0 from "./rightsManagement.vue?vue&type=style&index=0&id=6bebf863&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports